<template>
  <div class="">
    <h2 class="text-xl text-gray-800 font-bold pt-6">
      Subscription and Payment Information
    </h2>
    <p class="text-gray-800 mb-4">
      You are signing up for a monthly subscription with a recurring charge that
      will appear as "The Baking Notification Project" and will continue until
      you cancel. Subscriptions are managed through Square, and the Baking
      Notification Project does not store credit card information.
    </p>
    <div
      class="text-md text-gray-800 border-teal-400 border bg-teal-50 p-4 mb-4"
      v-if="baker.subscription_form === 'gather'"
    >
      <p class="mb-4">
        <strong>This project is in Gather mode.</strong> Once
        {{ baker.name }} gathers their first three subscribers, this project
        will become active and your subscription will begin. By subscribing now,
        you are showing your support and will receive baking notifications from
        {{ baker.name }} once their project becomes active.
      </p>
      <p>
        Your payment card will not be charged until this project becomes active.
      </p>
    </div>
    <div
      class="bg-white p-8 text-center shadow-md my-4 sm:mx-16 border-t-4 border-yellow-400"
    >
      <div class="text-4xl text-teal-700 font-black mb-1">
        $<span v-html="subscriptionCosts.currentCharge"></span>/month<span
          v-if="subscriptionCosts.specialNotice"
          >*</span
        >
      </div>
      <p
        v-if="subscriptionCosts.specialNotice"
        class="text-gray-800 text-md mb-4"
      >
        *{{ subscriptionCosts.specialNotice }}
      </p>
      <p class="text-gray-800">
        Access to baking notifications from {{ baker.name }}
      </p>
    </div>

    <square-credit-card
      v-if="isSquareLoaded"
      :app-id="baker.square_app_id"
      :location-id="baker.square_location_id"
      :error-description="
        creditCardError
          ? 'There was an error in processing your payment. Please check your credit card information. If the error persists, contact us at <a class=\'underline\' href=\'mailto:support@thebakingnotificationproject.com\'>support@thebakingnotificationproject.com</a>.'
          : ''
      "
      @square-card-created="cardCreated($event)"
    />

    <!--    <label class="inline-flex items-center mb-4">-->
    <!--      <input v-model="formData.billing_address_same_as_address" type="checkbox">-->
    <!--      <span class="ml-2">Billing Address same as mailing address</span>-->
    <!--    </label>-->

    <div
      v-if="!formData.billing_address_same_as_address"
      class="grid grid-cols-1 gap-0 pb-8"
    >
      <h2 class="text-xl text-gray-800 font-bold pb-2">Billing Address</h2>
      <TextInput
        v-model="formData.billing_address.name"
        name="billing_name"
        label="Billing Name"
        required
      ></TextInput>
      <TextInput
        v-model="formData.billing_address.street"
        name="billing_street_address"
        label="Street Address"
        required
      ></TextInput>
      <TextInput
        v-model="formData.billing_address.city"
        label="City"
        name="billing_city"
        required
      ></TextInput>
      <TextInput
        v-model="formData.billing_address.state"
        :maxlength="2"
        label="State"
        name="billing_state"
        description="Abbreviation (TN, NY, etc)"
        required
      ></TextInput>
      <TextInput
        v-model="formData.billing_address.zip"
        label="Zip Code"
        name="billing_zip_code"
        required
      ></TextInput>
    </div>
  </div>
</template>
<script>
import TextInput from "./form/TextInput.vue";
import SquareCreditCard from "./form/SquareCreditCard.vue";

export default {
  name: "PaymentProcessorSquare",
  components: { TextInput, SquareCreditCard },
  props: {
    baker: {
      type: Object,
      default() {
        return {};
      },
    },
    isSquareLoaded: {
      type: Boolean,
      default: false,
    },
    subscriptionCosts: {
      type: Object,
      default() {
        return {
          original: 10,
          currentCharge: 10,
          promoCodePrice: 0,
          specialNotice: null,
        };
      },
    },
    creditCardError: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: {
        billing_address: {},
        billing_address_same_as_address: true,
      },
      promo_code_message: null,
      promo_code_used_code: null,
    };
  },
  mounted() {
    this.subscriptionCosts.currentCharge = this.baker.subscription_price
      ? 1 * this.baker.subscription_price
      : 10;
    this.$forceUpdate();
  },
  methods: {
    cardCreated(data) {
      this.card = data;
      this.$emit("square-card-created", data);
    },
  },
};
</script>
